export const environment = {
  production: false,
  config: 'development'
  // config: 'production'
};
